




import Vue from 'vue';
import ProcessingStatusUsersList from '@/components/processing-status-users/processing-status-users-list.component.vue';

export default Vue.extend({
  components: {
    'processing-status-users-list': ProcessingStatusUsersList
  }
});
